var map = {
	"./banners/core-banner-1.jpg": "acf0",
	"./banners/core-banner-2.jpg": "abe0",
	"./core-default.png": "ff96",
	"./tab-default.jpg": "8dd6",
	"./tabs/core-connect-old.jpg": "4b23",
	"./tabs/core-connect.jpg": "ae4d",
	"./tabs/core-entertainment.jpg": "48d4",
	"./tabs/core-learn.jpg": "e2b0",
	"./tabs/core-save.jpg": "1a50",
	"./tabs/core-work.jpg": "54ce",
	"./vuma-core-banner.jpg": "69b9",
	"./vuma-fibre-process-1.svg": "2e0f",
	"./vuma-fibre-process-2.svg": "06ba",
	"./vuma-fibre-process-3.svg": "2964",
	"./vuma-fibre-process-4.svg": "63c3",
	"./vuma-fibre-process-5.svg": "bffb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6589";